import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 18px 0;
  max-width: 328px;

  @media (max-width: ${({ theme }) => theme.devices.tablet}) {
    max-width: 100%;
  }
`;

const Bullet = styled.div`
  height: 6px;
  width: 20px;
  background: ${({ theme }) => theme.colors.secondary};
  margin: 0 5px;
  border-radius: 10px;
  transition: 0.5s;
  opacity: 0.5;
  &:not(.active) {
    cursor: pointer;
  }

  &.active {
    opacity: 1;
    width: 40px;
  }
`;

const SliderBullets = ({ activeSlide, slidesLength, onChange }) => (
  <Container>
    {[...Array(slidesLength).keys()].map((slide, i) => (
      <Bullet
        key={i}
        className={i === activeSlide ? 'active' : ''}
        onClick={() => {
          if (i !== activeSlide) {
            onChange(i);
          }
        }}
      />
    ))}
  </Container>
);

SliderBullets.propTypes = {
  activeSlide: PropTypes.number.isRequired,
  slidesLength: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SliderBullets;
